var map = {
	"./adware.png": "7c6c",
	"./backdoor.png": "0fe9",
	"./bomb.png": "0361",
	"./botnet.png": "afb8",
	"./cyber-attack.png": "cbb2",
	"./keylogger.png": "b29f",
	"./malware.png": "a15d",
	"./ransomware.png": "87f6",
	"./spyware.png": "7ad9",
	"./trojan-horse.png": "1cb4",
	"./virus.png": "ea97",
	"./worm.png": "7901"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f6ca";